import React from 'react';

import { Container } from 'react-bootstrap';

import './StyleWarning.css';
// function test(){
// }
export default () => (
  <Container>
    <div className="Warning">
      <div className="warning-code">404</div>
      <div className="warning-status">
        ไม่พบหน้าที่ต้องการ
        <span className="warning-blue"> :(</span>
      </div>
    </div>
  </Container>
);
